<template>
  <graph-detail34-template
    :board-ids="[114, 234, 235, 236, 237]"
    field-code="facility-public"
    :com-group-list="comGroupList"
    graph1-title="전체 (공중(다중)이용시설) 관리 현황"
    graph2-title="월별 (공중(다중)이용시설) 관리 현황"
    graph3-title="기간별 (공중(다중)이용시설) 관리 현황"
    button-board="시설물 관리"
    field-category-label="구분"
    field-label="공중(다중)이용시설"
  />
</template>

<script>
/* eslint-disable brace-style */
import GraphDetail34Template from "@/views/graph-detail/GraphDetail34Template.vue";

export default {
  name: "GraphDetail71",
  components: {
    GraphDetail34Template,
  },
  props: {
    comGroupList: Object,
  },
};
</script>

<style scoped></style>
